module.exports = __webpack_public_path__ + "img/28.b7123e64.png";